{
  "loading": "Wird geladen...",
  "loadingMore": "Noch mehr wird geladen..."
}
